export enum Komponent {
  Bruger = 'bruger',
  Konfiguration = 'konfiguration',
  Soegning = 'soegning',
  Udbud = 'udbud'
}
